Customer.Reports ||= {}

class Customer.Reports.PieOptions # TODO: In which package Should be this class?!

  constructor: (@options) ->
    @onClick =  @options.onClick || () ->
    @legendItemClick = @options.legendItemClick

  get: ->
    options = {
      chart:
        renderTo: @options.container
        height: @options.height
        width: @options.width
        marginTop: 20
      title:
        text: null
      legend:
        y: 20
        itemStyle:
          width: 120
          textOverflow: "wrap"
        itemWidth: 130
        align: 'right'
        layout: 'vertical'
        verticalAlign: 'top'
        borderWidth: 0
        labelFormatter: -> "#{@name} #{@y}: #{Math.round(@percentage * 10) / 10}%"
      plotOptions:
        pie:
          allowPointSelect: true
          cursor: 'pointer'
          dataLabels:
            enabled: false
          showInLegend: true
      tooltip:
        formatter: -> "#{@point.name} #{@y}: #{Math.round(@percentage * 10) / 10}%"
      series:
        [{
          type: 'pie'
          name: 'Count'
          data: @options.data
          events:
            click: @onClick
          point:
            events:
              legendItemClick: @legendItemClick
        }]
    }
    options['exporting'] = @getExportingOptions() if @options.onToggleMaximize
    menuItems = Highcharts.getOptions().exporting.buttons.contextButton.menuItems
    menuItems = menuItems.concat({separator:true})
    unless window.sharedSession
      menuItems = menuItems.concat({
        text: if @options.isMaximized then I18n.t('monitoring.dashboard.charts.export_options.normal') else I18n.t('monitoring.dashboard.charts.export_options.maximize')
        onclick: (() => @options.onToggleMaximize())
      })
    menuItems = menuItems.concat(@exportingOptions)
    options.exporting.buttons.contextButton.menuItems = menuItems
    return options

  getExportingOptions: ->
    return buttons:
      contextButton:
        menuItems: []
        x: -12

